var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center pt-4"},[_c('div',{staticClass:"d-flex align-items-baseline"},[_c('b-spinner',{attrs:{"small":"","label":"Signing out"}}),_c('h4',{staticClass:"ml-2"},[_vm._v("Signing out..")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }